/**
 * Generato automaticamente.
 * framework-cmp-domande
 */

export type EnumDatiTitolareTipologia =
  (typeof EnumDatiTitolareTipologia)[keyof typeof EnumDatiTitolareTipologia];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumDatiTitolareTipologia = {
  TITOLARE: 'TITOLARE',
  SUPPORTO: 'SUPPORTO',
} as const;
